import styled from "@emotion/styled";

export const Provider = styled.div``;
